import * as yup from "yup";

import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IoSaveOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";

import Datepicker from "./../../../../../components/common/Datepicker";
import Toaster from "../../../../../components/common/Toaster";

import accountService from "../../../../../services/accountService";
import moment from "moment";

const schema = yup.object({
  started_on: yup.string().required("Please select date."),
});

const DateStartedForm = ({ data, isLoading, setLoading, onSuccess }) => {
  const [dateStarted, setDateStarted] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (item) => {
    try {
      setLoading(true);

      const account = { ...item };
      account["id"] = data.id;

      await accountService.saveDateStartedAsync(account);

      onSuccess(account.started_on);
      setLoading(false);
    } catch (ex) {
      Toaster.Error("Something went wrong.");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data) {
      const formatted_date = moment(data.started_on).format("MM-DD-yyyy");

      setValue("started_on", formatted_date);
      setDateStarted(formatted_date);
    }
  }, [data, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <Datepicker
            id="started-on-datepicker"
            name="started_on"
            title="Date Started"
            dateFormat="MM-DD-yyyy"
            timeFormat={false}
            setValue={setValue}
            value={dateStarted}
            onDateChange={setDateStarted}
            clearErrors={clearErrors}
            register={register("started_on")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default DateStartedForm;
